import { getUserEnv } from "./getUserEnv";
import { trackClarityEvent } from "./clarityTracking";
import {
  getLocaleFromPath,
  getBaseLang,
  getCurrency,
  DEFAULT_LOCALE,
} from "../../config/locales";

const _locale = getLocaleFromPath(window.location.pathname) ?? DEFAULT_LOCALE;
const round2 = (n) => Math.round(n * 100) / 100;

export const trackCheckoutEvent = ({
  eventType,
  transactionId,
  currency,
  value,
  tax = 0,
  shipping = 0,
  items = [],
  output,
}) => {
  if (!eventType || typeof value !== "number" || !output || !transactionId)
    return;

  const localeCurrency = getCurrency(_locale);
  const ecommerceCurrency = currency ?? localeCurrency;
  const roundedValue = round2(value);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: eventType,
    timestamp: new Date().toISOString(),
    output: output,
    user_env: getUserEnv(),
    user_language: getBaseLang(_locale),
    currency: localeCurrency,
    ecommerce: {
      transaction_id: transactionId,
      currency: ecommerceCurrency,
      value: roundedValue,
      tax: tax,
      shipping: shipping,
      items: items.map((item) => ({
        ...item,
        ...(typeof item.price === "number" && { price: round2(item.price) }),
      })),
    },
  });

  trackClarityEvent(eventType, {
    transaction_id: transactionId,
    currency: ecommerceCurrency,
    value: roundedValue,
    output: output,
  });
};
